import React from 'react';

export type DoorOpeningDirectionWidgetProps = {
  frameLeftSeriesConnector: string;
  frameRightSeriesConnector: string;
  frontConnectorLeft: string;
  frontConnectorRight: string;
};

const withDoorOpeningDirection = (
  frameLeftSeriesConnector: string,
  frameRightSeriesConnector: string,
  frontConnectorLeft: string,
  frontConnectorRight: string
) => (
  Component: React.FunctionComponent<DoorOpeningDirectionWidgetProps>
): React.FunctionComponent => (props: any) => (
  <Component
    {...props}
    frameLeftSeriesConnector={frameLeftSeriesConnector}
    frameRightSeriesConnector={frameRightSeriesConnector}
    frontConnectorLeft={frontConnectorLeft}
    frontConnectorRight={frontConnectorRight}
  />
);

export default withDoorOpeningDirection;
